<template>
        <b-modal :title="caption" v-model="dataShow" @ok="confirm" :ok-title="window.Core.Definition.getDefinition('Confirmer')" ok-variant="success" :cancel-title="window.Core.Definition.getDefinition('Annuler')" cancel-variant="light">
            <InputDateRangePicker
                    v-model="dataRange">
            </InputDateRangePicker>
            <table v-if="dataWeeks.length > 0" class="table table-striped">
                <thead>
                    <tr>
                        <th>
                            {{window.Core.Definition.getDefinition('Semaines')}}
                        </th>
                        <th>
                            <b-button @click="selectAll" type="button" class="btn btn-sm" :class="{ 'btn-success' : allSelected == true, 'btn-light' : allSelected == false }"><i class="fa fa-check"></i></b-button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="week, weekIndex in dataWeeks">
                        <td>{{week.label}}</td>
                        <td>
                            <b-button @click="select(weekIndex)" type="button" class="btn btn-sm" :class="{ 'btn-success' : dataWeeks[weekIndex].selected == true, 'btn-light' : dataWeeks[weekIndex].selected == false }"><i class="fa fa-check"></i></b-button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </b-modal>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import InputDateRangePicker from '../components/InputDateRangePicker'
    export default {
      name: 'ModalWeekSelector',
      components: {
          InputDateRangePicker
      },
      props: {
          caption: {
              type: String,
              default: ''
          },
          value: {
              type: Array,
              default: function() {
                  return []
              }
          },
      },
      watch: {
          dataRange: {
              handler(val) {
                  this.calcWeeks()
              },
              deep:true
          },
          dataWeeks: {
              handler(val) {
                  this.$emit('input', val)
              },
              deep: true
          }
      },
      mounted() {
      },
      data: () => {
          return {
              window: window,
              dataShow: false,
              dataRange: null,
              dataWeeks: [],
              dataAllSelected: false
          }
      },
      computed: {
          open: {
            set(val) {
                this.dataShow = val
            },
            get() {
                return this.dataShow
            }
          },
          allSelected() {
              //let allSelected = false
              let selectedCount = 0
              for(let week in this.dataWeeks) {
                  if (this.dataWeeks[week].selected) {
                      selectedCount ++
                  }
              }
              if (selectedCount === this.dataWeeks.length) {
                  this.dataAllSelected = true
              } else {
                  this.dataAllSelected = false
              }
              return this.dataAllSelected
          },
          selectedWeeks() {
              let selectedWeeks = []
              for(let week in this.dataWeeks) {
                  week = this.dataWeeks[week]
                  if (week.selected) {
                      selectedWeeks.push(week.date)
                  }
              }
              return selectedWeeks
          }
      },
      methods: {
          calcWeeks() {
              this.dataWeeks = []

              let format = 'YYYY-MM-DD'
              let start = this.dataRange.start
              let end = this.dataRange.end

              if (Vue.moment(start).isValid() && Vue.moment(end).isValid()) {
                  start = Vue.moment(start, format);
                  end = Vue.moment(end, format);
                  let weekCount = (end.diff(start, 'days') / 7).toFixed(1);
                  let week = Vue.moment(this.dataRange.start).startOf('isoWeek').format(format)
                  for(let weekIndex = 0; weekIndex < weekCount; weekIndex ++){
                      this.dataWeeks.push({
                          date: week,
                          selected: true,
                          label: Vue.moment(week).startOf('isoWeek').format('DD MMM YYYY') + ' - ' + Vue.moment(week).endOf('isoWeek').format('DD MMM YYYY')
                      })
                      week = Vue.moment(week).add(1, 'week').format(format)
                  }
              }
          },
          confirm(e) {
              e.preventDefault()
              this.$emit('onConfirm', this.selectedWeeks)
              this.open = false
          },
          select(weekIndex) {
              if (this.dataWeeks[weekIndex].selected == true) {
                  this.dataWeeks[weekIndex].selected = false
              } else {
                  if (this.dataWeeks[weekIndex].selected == false) {
                      this.dataWeeks[weekIndex].selected = true
                  }
              }
          },
          selectAll() {
              if (this.dataAllSelected) {
                  for(let week in this.dataWeeks) {
                      if (this.dataWeeks[week].selected == true) {
                          this.dataWeeks[week].selected = false
                      }
                  }
              } else {
                  for(let week in this.dataWeeks) {
                      if (this.dataWeeks[week].selected == false) {
                          this.dataWeeks[week].selected = true
                      }
                  }
              }
          }
      }
  }
</script>